// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3P2W7","colMaxWidth":"Table_colMaxWidth__1E1Sw"};